import api from "@/api";

export default {
    namespaced: true,

    state: {
        giveaway: {
            enabled: false,
            participates: false,
        },
        place_info: {
            place: {
                name: '',
            },
            question: ''
        },
        questionUid: null,
        rateValue: null,
        rateUid: null,
    },

    getters: {
        getGiveaway(state) {
            return state.giveaway
        },
        getPlaceInfo(state) {
            return state.place_info
        },
        getRateValue(state) {
            return state.rateValue
        },
        getRateUid(state) {
            return state.rateUid
        },
        getQuestionUid(state) {
            return state.questionUid
        },
    },
    mutations: {
        setGiveawayEnabled(state, value) {
            state.giveaway.enabled = value
        },
        setGiveawayParticipates(state, value) {
            state.giveaway.participates = value
        },
        setGiveawayDescription(state, value) {
            state.giveaway.description = value
        },
        setGiveawayTitle(state, value) {
            state.giveaway.giveaway_title = value
        },
        clearGiveaway(state) {
            state.giveaway.participates = false
        },
        setPlaceInfo(state, value) {
            state.place_info = value
        },
        setRateValue(state, value) {
            state.rateValue = value
        },
        setRateUid(state, value) {
            state.rateUid = value
        },
        setQuestionUid(state, value) {
            state.questionUid = value
        },
    },

    actions: {
        async sendRateDetails(context, payload) {
            const url = context.rootState.auth.accessToken ? `/api/v1/sendRateDetails` : `/api/sendRateDetails`
            const data = {
                question_id: payload.question_id,
                rate: payload.index,
                screen_width: window.screen.width,
                screen_height: window.screen.height,
                inner_width: window.innerWidth,
                inner_height: window.innerHeight,
                mode: payload.mode,
                is_lead: payload.is_lead
            };

            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            return await api.request("post", url, data, null, forceToken);
        },

        async fetchQuestionInfo(context, payload) {
            const url = context.rootState.auth.accessToken ? `/api/v1/questionInfo` : `/api/questionInfo`
            const data = {
                question_id: payload.question_id,
            };

            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            return await api.request("post", url, data, null, forceToken);
        },
        async sendRate(context, payload) {
            let url = `${payload.userStatus}?question_id=${payload.question_id}&rate=${payload.index}`;
            return await api.request("get", url);
        },

        async getRateInfo(context, question_id) {
            console.log('question_id', question_id)
            console.log('111111111111111:context.rootState.sessionToken', context.rootState.auth.accessToken)
            const url = context.rootState.auth.accessToken ? `/api/v1/questions/${question_id}` : `/api/questions/${question_id}`
            return await api.request("get", url);
        },

        async changeRate(context, {changeRateID, rate}) {
            var url = `/api/v1/changeRate?rate_id=${changeRateID}&rate=${rate}`;
            if (!localStorage.getItem('access_token')) {
                url = `/api/changeRateWithoutAuth?rate_id=${changeRateID}&rate=${rate}`;
            }
            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            return await api.request("get", url, null, null, forceToken);
        },

        async sendSocialClick(context, payload) {
            var url = context.rootState.auth.accessToken ? `/api/v1/sendSocialClick` : `/api/sendSocialClickWithoutAuth`
            url += `?rate_id=${payload.rateUid}&link_id=${payload.linkUid}`;
            return await api.request("get", url);
        },

        async sendVoteGeolocation(context, {voteId, body}) {
            const prefix = context.rootState.auth.accessToken ? 'v1/' : ''

            let url = `/api/${prefix}votes/${voteId}/geolocation`;

            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            return await api.request("put", url, body, null, forceToken);
        },
        async sendLocationIsOld(context, {voteId, body}) {
            const prefix = context.rootState.auth.accessToken ? 'v1/' : ''

            let url = `/api/${prefix}votes/${voteId}/geolocationOld`;

            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            return await api.request("post", url, body, null, forceToken);
        },
        async handleAnswer(context, {vote_uid, option, isDelete}) {
            let prefix = context.rootState.auth.accessToken ? '/v1' : ''
            let body = {
                option: option,
                date: (new Date()).toISOString(),
            }
            const url = `/api${prefix}/votes/${vote_uid}/secAnswer`

            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            const response = await api.request(isDelete ? "delete" : "post", url, body, null, forceToken)
            return response.data
        },

        async changeQuestionPlacement(context, {questionGuid, placement}) {
            let body = {placement: placement}
            let url = `/api/v1/questions/${questionGuid}/placement`;
            return await api.request("put", url, body);
        },

        async getServiceLogInfo(context, {questionGuid, rate_uid}) {
            let prefix = context.rootState.auth.accessToken ? '/v1' : ''
            let url = `/api${prefix}/questions/${questionGuid}/getRateServiceLogInfo`
            if(rate_uid) {
                url = url + `?rate_uid=${rate_uid}`
            }
            return await api.request("get", url)
        },

        async getPDFFogRequest(context, {questionGuid, email}) {
            let prefix = context.rootState.auth.accessToken ? '/v1' : ''
            let url = `/api${prefix}/questions/${questionGuid}/pdf-request?email=${encodeURIComponent(email)}`
            return await api.request("get", url)
        },

        async changeRateAdditionalData(context, {vote_uid, body}) {
            let prefix = context.rootState.auth.accessToken ? '/v1' : ''
            let url = `/api${prefix}/votes/${vote_uid}/rateAdditionalData`
            return await api.request("post", url, body)
        },

    }
};
